import { API_URL } from "../config/api_url";

function getToken() {
  return localStorage.getItem("customer_access_token");
}

function buildHeaders(extraHeaders = {}, isFormData = false) {
  const headers = new Headers(extraHeaders);

  const token = getToken();
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (!isFormData && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  return headers;
}

async function handleResponse(response) {
  const contentType = response.headers.get("content-type");
  let data;

  if (contentType && contentType.includes("application/json")) {
    data = await response.json();
  } else {
    data = await response.text();
  }

  if (!response.ok) {
    const message =
      data?.message ||
      data?.error ||
      data?.details ||
      data ||
      `HTTP ${response.status}`;

    const err = new Error(message);
    err.status = response.status;
    err.payload = data;
    throw err;
  }

  return data;
}

export async function apiGet(path) {
  const response = await fetch(`${API_URL}${path}`, {
    method: "GET",
    headers: buildHeaders(),
  });

  return handleResponse(response);
}

export async function apiPost(path, body) {
  const response = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(body),
  });

  return handleResponse(response);
}

export async function apiPostForm(path, formData) {
  const response = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: buildHeaders({}, true),
    body: formData,
  });

  return handleResponse(response);
}

export async function apiGetBlob(path) {
  const response = await fetch(`${API_URL}${path}`, {
    method: "GET",
    headers: buildHeaders(),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }

  const blob = await response.blob();
  return {
    blob,
    headers: response.headers,
  };
}